/**
 * Video templates: the input photo as a small card in the corner of the
 * playing clip ("your photo → this video"). A slider would cover the motion.
 * Styles: styles/compareSlider.css (.bfi).
 */
import { escapeHtml } from './placeholder.js';
import { icon } from './icon.js';

export function beforeInsetHtml(url: string, className = ''): string {
  return `
    <div class="bfi ${className}" aria-hidden="true">
      <span class="bfi-arrow">${icon('arrow_back')}</span>
      <span class="bfi-card">
        <img src="${escapeHtml(url)}" alt="" decoding="async" />
        <span class="bfi-label">Your photo</span>
      </span>
    </div>`;
}
